import { useState, useEffect } from 'react';
import { Edit, Trash2, Plus } from 'lucide-react';
import { adminUsers, adminRoleChange, adminUserDelete } from '../../api';

const RC={admin:'bg-red-100 text-red-600',paid:'bg-green-100 text-green-600',gifted:'bg-purple-100 text-purple-600',free:'bg-gray-100 text-gray-600',guest:'bg-orange-100 text-orange-600'};
const ROLES=['guest','free','paid','gifted','admin'];

export default function UsersTab() {
  const [users,setUsers]   = useState([]);
  const [loading,setLoad]  = useState(true);
  const [search,setSearch] = useState('');
  const [msg,setMsg]       = useState('');

  useEffect(()=>{ adminUsers().then(r=>setUsers(r.data.users||[])).catch(()=>{}).finally(()=>setLoad(false)); },[]);

  const changeRole = async(id,role)=>{
    try{
      const exp = role==='gifted' ? prompt('Expiry date (YYYY-MM-DD) or leave blank for permanent:') : undefined;
      await adminRoleChange(id,role,exp||undefined);
      setUsers(u=>u.map(x=>x.id===id?{...x,role}:x));
      setMsg('Role updated successfully');
      setTimeout(()=>setMsg(''),2000);
    }catch{ setMsg('Failed to update role'); setTimeout(()=>setMsg(''),2000); }
  };

  const deleteUser = async id=>{
    if(!window.confirm('Delete this user? This cannot be undone.')) return;
    try{ await adminUserDelete(id); setUsers(u=>u.filter(x=>x.id!==id)); }catch{}
  };

  const filtered = users.filter(u=>u.name.toLowerCase().includes(search.toLowerCase())||u.email.toLowerCase().includes(search.toLowerCase()));

  if(loading) return <div className="text-center py-20 text-gray-400">Loading users...</div>;

  return(
    <>
      {msg&&<div className="mb-4 bg-green-50 border border-green-200 text-green-700 text-sm px-4 py-2 rounded-xl">{msg}</div>}
      <div className="flex items-center justify-between mb-4">
        <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search by name or email..." className="border border-gray-200 rounded-xl px-4 py-2 text-sm outline-none focus:border-blue-500 w-64"/>
        <span className="text-sm text-gray-500">{filtered.length} users</span>
      </div>
      <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead><tr className="text-left text-xs text-gray-400 bg-gray-50 border-b"><th className="px-4 py-3">Name</th><th className="px-4 py-3">Email</th><th className="px-4 py-3">Role</th><th className="px-4 py-3">Expires</th><th className="px-4 py-3">Joined</th><th className="px-4 py-3">Change Role</th><th className="px-4 py-3">Actions</th></tr></thead>
            <tbody>{filtered.map(u=>(
              <tr key={u.id} className="border-b border-gray-50 hover:bg-gray-50">
                <td className="px-4 py-3 font-medium">{u.name}</td>
                <td className="px-4 py-3 text-gray-400 text-xs">{u.email}</td>
                <td className="px-4 py-3"><span className={"text-xs px-2 py-0.5 rounded-full font-semibold "+(RC[u.role]||'')}>{u.role}{u.role==='gifted'?' 🎁':''}</span></td>
                <td className="px-4 py-3 text-xs text-gray-400">{u.expires_at?new Date(u.expires_at).toLocaleDateString():'—'}</td>
                <td className="px-4 py-3 text-xs text-gray-400">{u.created_at?new Date(u.created_at).toLocaleDateString():'—'}</td>
                <td className="px-4 py-3">
                  <select value={u.role} onChange={e=>changeRole(u.id,e.target.value)} className="text-xs border border-gray-200 rounded-lg px-2 py-1 outline-none focus:border-blue-400">
                    {ROLES.map(r=><option key={r} value={r}>{r}{r==='gifted'?' 🎁':''}</option>)}
                  </select>
                </td>
                <td className="px-4 py-3"><button onClick={()=>deleteUser(u.id)} className="text-red-400 hover:text-red-600"><Trash2 size={14}/></button></td>
              </tr>
            ))}</tbody>
          </table>
        </div>
      </div>
    </>
  );
}
